import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "col" }
const _hoisted_2 = {
  key: 1,
  class: "table table-sm table-hover table-borderless"
}
const _hoisted_3 = { style: {"width":"64px"} }
const _hoisted_4 = { style: {"width":"64px"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", null, null, -1)

import { Paging, ProductInfo, Query } from '@/types/api'
import { computed, onBeforeMount, ref, watch } from 'vue'
import { fillQueryParamsFromQueryString, promoteParamsToSearch } from '@/helpers/tools'
import { useStore } from "vuex";
import AppPagination from "@/components/app/AppPagination.vue";
import AppLoadingMessage from "@/components/app/AppLoadingMessage.vue";
import AppImageLightBox from "@/components/app/AppImageLightBox.vue";
import SilpoProductInfoActions from "@/components/shopping/silpo/SilpoProductInfoActions.vue";
import SilpoCategoryPath from "@/components/shopping/silpo/SilpoCategoryPath.vue";
import AppEmptyListAlert from "@/components/app/AppEmptyListAlert.vue";
import { useRouter } from "vue-router";

interface Model extends Query {
  filter: {
    favourite: boolean
  }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SilpoProducts',
  setup(__props) {

const store = useStore()
const router = useRouter()

const model = ref<Model>({ filter: { favourite: false }, paging: { page: 1, per_page: 10 } })

const products = computed<ProductInfo[]>((): ProductInfo[] => store.getters['shopping/silpo/products/items'])
const productsIsLoading = computed<boolean>((): boolean => store.getters['shopping/silpo/products/isLoading'])

watch((): Model => model.value, async (current: Model): Promise<void> => {
  await store.dispatch('shopping/silpo/products/updateQuery', current)
  promoteParamsToSearch(current, router)
}, { deep: true })

function onPageChanged (paging: Paging): void {
  model.value.paging = paging
}

onBeforeMount(async (): Promise<void> => {
  model.value = fillQueryParamsFromQueryString(model.value)

  await store.dispatch('shopping/silpo/products/updateQuery', model.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["row", {'cursor-progress': _unref(productsIsLoading)}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AppPagination, {
        "total-count": _unref(products).total_count,
        page: model.value.paging.page,
        per_page: model.value.paging.per_page,
        disabled: _unref(productsIsLoading),
        onPageChanged: onPageChanged
      }, null, 8, ["total-count", "page", "per_page", "disabled"]),
      (_unref(productsIsLoading))
        ? (_openBlock(), _createBlock(AppLoadingMessage, { key: 0 }))
        : (_unref(products).items.length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(products).items, (product) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: product.lager_id
                }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(AppImageLightBox, {
                          images: [product.image_url || '/images/square-placeholder.jpeg'],
                          alt: product.lager_name,
                          "loading-image": "/images/square-placeholder.jpeg"
                        }, null, 8, ["images", "alt"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", null, _toDisplayString(product.lager_name), 1),
                      _createVNode(SilpoProductInfoActions, {
                        "price-chart-height": "200px",
                        "vendor-code": product.vendor_code,
                        "buying-count": product.product_buying_count
                      }, null, 8, ["vendor-code", "buying-count"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_5,
                    _createElementVNode("td", null, [
                      _createVNode(SilpoCategoryPath, {
                        "vendor-code": product.vendor_code,
                        "category-id": product.category_id
                      }, null, 8, ["vendor-code", "category-id"])
                    ])
                  ])
                ], 64))
              }), 128))
            ]))
          : (_openBlock(), _createBlock(AppEmptyListAlert, { key: 2 }, {
              default: _withCtx(() => [
                _createTextVNode("No products")
              ]),
              _: 1
            }))
    ])
  ], 2))
}
}

})